import { HeroStoryblokCustom } from "@/types/globals";
import StoryblokComponent from "../../../storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import styles from "../hero.module.css";
import OpacityLayer from "./OpacityLayer";

const ImageBlok = ({
  media,
  backgroundOpacity,
  preview,
  mobileImageLayout,
}: {
  media: HeroStoryblokCustom["media"];
  backgroundOpacity: HeroStoryblokCustom["backgroundOpacity"];
  preview?: boolean;
  mobileImageLayout: Exclude<
    HeroStoryblokCustom["mobileImagesLayout"],
    undefined | ""
  >;
}) =>
  !media || media.length < 1 ? null : (
    <div
      className={styles.images__wrapper}
      style={{ gridTemplateColumns: `repeat(${media.length}, 1fr)` }}
      data-mobile-layout={mobileImageLayout}
    >
      {media.map((img, index) => (
        <div
          className={styles.image__wrapper}
          key={img._uid}
          data-mobile-index={index}
        >
          <OpacityLayer value={backgroundOpacity?.value} />
          <StoryblokComponent blok={img} preview={preview} />
        </div>
      ))}
    </div>
  );

export default ImageBlok;
